"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IconActionChevronLeft = function IconActionChevronLeft(_ref) {
  var className = _ref.className,
      color = _ref.color,
      size = _ref.size;
  return /*#__PURE__*/_react.default.createElement("svg", {
    id: "icons",
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 50 50",
    fill: "none"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M31.5 40.5L18.5 27.5L31.5 14.5",
    stroke: color,
    strokeWidth: "4",
    strokeMiterlimit: "10"
  }));
};

IconActionChevronLeft.defaultProps = {
  color: 'black',
  size: 30
};
IconActionChevronLeft.propTypes = {
  color: _propTypes.string,
  className: _propTypes.string
};
var _default = IconActionChevronLeft;
exports.default = _default;